
      // Countdown to local midnight 
      function updateCountdown() {
        const digitsEl   = document.getElementById('countdownDigits'); // SR/legacy
        const fallbackEl = document.getElementById('countdown');       // container
        const barEl      = document.getElementById('countdownBarFill');// optional

        // Structured H/M/S spans (preferred)
        const hEl = document.getElementById('ubH') || document.getElementById('cd-h');
        const mEl = document.getElementById('ubM') || document.getElementById('cd-m');
        const sEl = document.getElementById('ubS') || document.getElementById('cd-s');

        if (!digitsEl && !fallbackEl && !(hEl && mEl && sEl)) return;

        const pad = n => n.toString().padStart(2, '0');
        const totalSecondsInDay = 24 * 60 * 60;
        const nextLocalMidnight = () => {
          const now = new Date();
          const t = new Date(now);
          t.setHours(24, 0, 0, 0);
          return t;
        };

        let timerId = null;

        function render() {
          const left = Math.max(0, Math.floor((nextLocalMidnight() - new Date()) / 1000));
          const h = Math.floor(left / 3600);
          const m = Math.floor((left % 3600) / 60);
          const s = left % 60;

          if (hEl && mEl && sEl) {
            hEl.textContent = pad(h);
            mEl.textContent = pad(m);
            sEl.textContent = pad(s);
          } else {
            const text = `${pad(h)}:${pad(m)}:${pad(s)}`;
            if (digitsEl) digitsEl.textContent = text;
            else if (fallbackEl) fallbackEl.textContent = text;
          }

          if (digitsEl) {
            digitsEl.textContent = `${pad(h)}:${pad(m)}:${pad(s)}`;
            digitsEl.setAttribute('aria-label', `${h} hours ${m} minutes ${s} seconds remaining today`);
          }

          if (barEl) barEl.style.width = (left / totalSecondsInDay * 100) + '%';
        }

        function stop() { if (timerId) { clearTimeout(timerId); timerId = null; } }

        function startAligned() {
          stop();
          render();
          const delay = 1000 - (Date.now() % 1000);
          timerId = setTimeout(function loop() {
            render();
            timerId = setTimeout(loop, 1000);
          }, delay);
        }

        document.addEventListener('visibilitychange', () => {
          if (document.hidden) stop(); else startAligned();
        }, { passive: true });

        startAligned();
      }

      //SINGLE SOURCE OF TRUTH: Urgency Ticker 
      (function initUrgencyTicker() {
        const track = document.getElementById('tickerTrack');
        if (!track) return;

        const wrapper = track.closest('.ticker') || track.parentElement;
        const prefersReduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        // Cache originals for clean rebuilds
        const originals = Array.from(track.children).map(n => n.cloneNode(true));

        function ensureFill() {
          track.innerHTML = '';
          originals.forEach(n => track.appendChild(n.cloneNode(true)));

          // Duplicate until >= 2x wrapper width for seamless loop
          let safety = 12;
          while (track.scrollWidth < (wrapper.clientWidth * 2) && safety-- > 0) {
            originals.forEach(node => track.appendChild(node.cloneNode(true)));
          }
        }

        function setSpeed() {
          const PX_PER_SEC = 60; // adjust to taste
          const contentWidth = track.scrollWidth / 2 || track.scrollWidth || 1000;
          const dur = contentWidth / PX_PER_SEC;
          track.style.animationDuration = `${dur}s`;
        }

        ensureFill();

        if (prefersReduce) {
          // Reduced motion: disable CSS animation, gentle scroll
          track.style.animation = 'none';
          let pos = 0;
          let tickId = null;
          const step = 0.6;
          const loop = () => {
            pos += step;
            const half = track.scrollWidth / 2;
            if (pos >= half) pos = 0;
            wrapper.scrollLeft = pos;
            tickId = setTimeout(loop, 16);
          };
          const start = () => { if (!tickId) loop(); };
          const stop  = () => { if (tickId) { clearTimeout(tickId); tickId = null; } };
          wrapper.addEventListener('mouseenter', stop);
          wrapper.addEventListener('mouseleave', start);
          wrapper.addEventListener('focusin', stop);
          wrapper.addEventListener('focusout', start);
          start();
        } else {
          // CSS animation path: compute duration dynamically
          setSpeed();
          let resizeTO;
          window.addEventListener('resize', () => {
            clearTimeout(resizeTO);
            resizeTO = setTimeout(() => {
              ensureFill();
              setSpeed();
            }, 120);
          }, { passive: true });
        }

        requestAnimationFrame(() => { track.style.visibility = 'visible'; });
      })();

      // Smooth scrolling  
      document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
          e.preventDefault();
          const target = document.querySelector(this.getAttribute('href'));
          if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });

      // Fade-in animations 
      const observerOptions = { threshold: 0.1, rootMargin: '0px 0px -50px 0px' };
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => { if (entry.isIntersecting) entry.target.classList.add('fade-in'); });
      }, observerOptions);
      document.querySelectorAll('.value-item, .book-card, .pricing-card, .testimonial').forEach(el => observer.observe(el));

      //Init single countdown 
      updateCountdown();

      // Carousel 
      document.addEventListener('DOMContentLoaded', () => {
        const track = document.getElementById('track'); // regular carousel
        if (!track) return;

        const children = Array.from(track.children);
        children.forEach(node => track.appendChild(node.cloneNode(true)));

        if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          track.style.animation = 'none';
          const wrapper = document.querySelector('.carousel-wrapper');
          let pos = 0;
          const step = 0.6;
          setInterval(() => {
            pos += step;
            if (pos >= track.scrollWidth / 2) pos = 0;
            wrapper.scrollLeft = pos;
          }, 16);
        }
        requestAnimationFrame(() => track.style.visibility = 'visible');
      });

      // Modal form
      const modal = document.getElementById("popupForm");
      const closeBtn = document.querySelector(".close-btn");
      const buttons = document.querySelectorAll(".book-btn");
      const formResponse = document.getElementById("formResponse");
      const form = document.getElementById("bookForm");
      let selectedBook = "";

      if (modal) { modal.classList.remove("show"); modal.removeAttribute("style"); }

      function openModal(book) {
        selectedBook = book || "";
        if (formResponse) formResponse.textContent = "";
        if (modal) { modal.classList.add("show"); modal.setAttribute("aria-hidden", "false"); }
      }
      function closeModal() {
        if (modal) { modal.classList.remove("show"); modal.setAttribute("aria-hidden", "true"); }
      }
      buttons.forEach(btn => btn.addEventListener("click", () => openModal(btn.getAttribute("data-book"))));
      if (closeBtn) ["click", "touchend"].forEach(evt => closeBtn.addEventListener(evt, closeModal));
      window.addEventListener("click", e => { if (e.target === modal) closeModal(); });

      const scriptURLBook = "https://script.google.com/macros/s/AKfycbziePI-VwyiC2GrXfIWMVS-TJzixcaJHuto5tBHm0_wVM-rXn51zh1Uh4DUNbOa7fn6tA/exec";
      if (form) {
        form.addEventListener("submit", async (e) => {
          e.preventDefault();
          const formData = new FormData(form);
          formData.append("book", selectedBook);
          if (formResponse) { formResponse.style.color = "blue"; formResponse.textContent = "⏳ Submitting... Please wait."; }
          try {
            const res = await fetch(scriptURLBook, { method: "POST", body: formData });
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            if (formResponse) { formResponse.style.color = "green"; formResponse.textContent = "✅ Submitted! Check your email for the link."; }
            form.reset();
            setTimeout(() => { closeModal(); selectedBook = ""; }, 1200);
          } catch (error) {
            if (formResponse) { formResponse.style.color = "red"; formResponse.textContent = "❌ Error, please try again."; }
            console.error("Error!", error);
          }
        });
      }

      //Scroll-triggered animations: books (
      const faders = document.querySelectorAll(".fade-in-up");
      const appearOptions = { threshold: 0.2, rootMargin: "0px 0px -50px 0px" };
      const appearOnScroll = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => { if (!entry.isIntersecting) return; entry.target.classList.add("show"); observer.unobserve(entry.target); });
      }, appearOptions);
      faders.forEach(fader => appearOnScroll.observe(fader));

      //Scroll-triggered animations: text-image
      document.addEventListener("DOMContentLoaded", () => {
        const faders2 = document.querySelectorAll('.fade-in-left, .fade-in-right');
        const appearOnScroll2 = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('visible'); observer.unobserve(entry.target); } });
        }, { threshold: 0.2 });
        faders2.forEach(f => appearOnScroll2.observe(f));
      });



      //Testimonials carousel      
      document.addEventListener('DOMContentLoaded', () => {
        const tsTrack = document.getElementById('ts-track');
        if (!tsTrack) return;

        const wrapper = tsTrack.closest('.ts-carousel-wrapper');
        const viewport = wrapper?.querySelector('.ts-carousel-viewport');
        
        // Get all cards (first 8 are unique, rest are duplicates)
        const allCards = Array.from(tsTrack.children);
        const uniqueCount = 8;
        const slides = allCards.slice(0, uniqueCount);
        
        // Hide duplicate cards
        for (let i = uniqueCount; i < allCards.length; i++) {
          allCards[i].style.display = 'none';
        }
        
        // Create controls
        const controls = document.createElement('div');
        controls.className = 'ts-controls';
        controls.setAttribute('aria-label', 'Testimonial controls');
        
        const prevBtn = document.createElement('button');
        prevBtn.className = 'ts-btn ts-prev';
        prevBtn.type = 'button';
        prevBtn.setAttribute('aria-label', 'Previous');
        prevBtn.textContent = '‹';
        
        const dots = document.createElement('div');
        dots.className = 'ts-dots';
        dots.setAttribute('role', 'tablist');
        
        const nextBtn = document.createElement('button');
        nextBtn.className = 'ts-btn ts-next';
        nextBtn.type = 'button';
        nextBtn.setAttribute('aria-label', 'Next');
        nextBtn.textContent = '›';
        
        controls.appendChild(prevBtn);
        controls.appendChild(dots);
        controls.appendChild(nextBtn);
        wrapper.appendChild(controls);
        
        // Create dots
        for (let i = 0; i < slides.length; i++) {
          const dot = document.createElement('button');
          dot.className = 'ts-dot';
          dot.type = 'button';
          dot.setAttribute('role', 'tab');
          dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
          dots.appendChild(dot);
        }
        
        let index = 0;
        let isAnimating = false;
        let autoTimer = null;
        
        function getSlideWidth() {
          const card = slides[0];
          if (!card) return 0;
          
          const cardRect = card.getBoundingClientRect();
          const gap = parseFloat(getComputedStyle(tsTrack).gap) || 22;
          
          return cardRect.width + gap;
        }
        
        function updateDots() {
          const allDots = Array.from(dots.querySelectorAll('.ts-dot'));
          allDots.forEach((d, i) => {
            d.setAttribute('aria-current', i === index ? 'true' : 'false');
          });
        }
        
        function updateButtons() {
          prevBtn.disabled = index === 0;
          nextBtn.disabled = index === slides.length - 1;
        }
        
        function goTo(i, userInitiated = false) {
          if (isAnimating) return;
          
          // Clamp index
          index = Math.max(0, Math.min(i, slides.length - 1));
          isAnimating = true;
          
          const offset = getSlideWidth() * index;
          tsTrack.style.transform = `translateX(-${offset}px)`;
          
          updateDots();
          updateButtons();
          
          setTimeout(() => { isAnimating = false; }, 550);
          
          if (userInitiated) restartAuto();
        }
        
        function next() { 
          if (index < slides.length - 1) {
            goTo(index + 1, true); 
          }
        }
        
        function prev() { 
          if (index > 0) {
            goTo(index - 1, true); 
          }
        }
        
        function startAuto() {
          stopAuto();
          autoTimer = setInterval(() => {
            if (index >= slides.length - 1) {
              goTo(0, false);
            } else {
              goTo(index + 1, false);
            }
          }, 5000);
        }
        
        function stopAuto() {
          if (autoTimer) {
            clearInterval(autoTimer);
            autoTimer = null;
          }
        }
        
        function restartAuto() {
          stopAuto();
          startAuto();
        }
        
        // Button handlers
        prevBtn.onclick = prev;
        nextBtn.onclick = next;
        
        // Dot handlers
        Array.from(dots.querySelectorAll('.ts-dot')).forEach((dot, i) => {
          dot.onclick = () => goTo(i, true);
        });
        
        // Pause on hover
        wrapper.addEventListener('mouseenter', stopAuto);
        wrapper.addEventListener('mouseleave', startAuto);
        
        // Touch swipe
        let startX = 0, currentX = 0, touching = false;
        
        viewport.addEventListener('touchstart', (e) => {
          touching = true;
          startX = e.touches[0].clientX;
          currentX = startX;
          stopAuto();
        }, { passive: true });
        
        viewport.addEventListener('touchmove', (e) => {
          if (!touching) return;
          currentX = e.touches[0].clientX;
        }, { passive: true });
        
        viewport.addEventListener('touchend', () => {
          if (!touching) return;
          touching = false;
          
          const deltaX = currentX - startX;
          const threshold = 50;
          
          if (deltaX > threshold && index > 0) {
            prev();
          } else if (deltaX < -threshold && index < slides.length - 1) {
            next();
          } else {
            startAuto();
          }
        });
        
        // Handle resize
        let resizeTimeout;
        window.addEventListener('resize', () => {
          clearTimeout(resizeTimeout);
          resizeTimeout = setTimeout(() => {
            goTo(index, false);
          }, 150);
        });
        
        // Initialize
        goTo(0, false);
        startAuto();
        
        // Make visible
        requestAnimationFrame(() => {
          tsTrack.style.visibility = 'visible';
        });
      });

      // Floating Form 
      (function () {
        const root       = document.getElementById('vpCF');
        const closeBtn   = document.getElementById('vpCF-close');
        const toggleBtn  = document.getElementById('vpCF-toggle');
        const fab        = document.getElementById('vpCF-fab');
        const form       = document.getElementById('vpCF-form');
        const submitBtn  = document.getElementById('vpCF-submit');
        const toast      = document.getElementById('vpCF-toast');
        const multi      = document.querySelector('.vpCF-multi');
        const display    = document.getElementById('vpCF-multi-display');
        const options    = document.getElementById('vpCF-options');

        let success = document.getElementById('vpCF-success');
        if (!success && submitBtn && submitBtn.parentNode) {
          success = document.createElement('div');
          success.id = 'vpCF-success';
          success.className = 'vpCF-success';
          success.setAttribute('role', 'status');
          success.setAttribute('aria-live', 'polite');
          success.hidden = true;
          submitBtn.parentNode.insertBefore(success, submitBtn);
        }

        const formChildren = form ? Array.from(form.children) : [];
        let userToggled = false;
        let portaled = false;
        const isMobile = () => window.innerWidth <= 768;

        function showOnlySuccess(msg) {
          if (!form) return;
          form.reset();
          if (options) options.querySelectorAll('input[type="checkbox"]').forEach(i => (i.checked = false));
          if (display) display.textContent = 'Select books';
          if (options) options.classList.remove('active');
          closeOptionsPortal();
          formChildren.forEach(el => { el.style.display = 'none'; });
          success.textContent = msg || 'Thank you for submitting the form! Our team will reach out to you shortly.';
          success.hidden = false;
          success.style.display = 'block';
          success.classList.add('show');
        }
        function restoreFormUI() {
          formChildren.forEach(el => { el.style.removeProperty('display'); });
          success.classList.remove('show');
          success.hidden = true;
          success.style.display = 'none';
        }

        const setInitial = () => {
          if (!root) return;
          if (userToggled) {
            if (isMobile()) {
              toggleBtn && (toggleBtn.style.display = 'none');
              const isOpen = root.classList.contains('vpCF-visible') && !root.classList.contains('vpCF-hidden-desktop');
              fab && (fab.style.display = isOpen ? 'none' : 'flex');
            } else {
              fab && (fab.style.display = 'none');
              const isHidden = root.classList.contains('vpCF-hidden-desktop');
              toggleBtn && (toggleBtn.style.display = isHidden ? 'inline-flex' : 'none');
            }
            return;
          }
          if (isMobile()) {
            root.classList.remove('vpCF-visible');
            root.classList.add('vpCF-hidden-desktop');
            fab && (fab.style.display = 'flex');
            toggleBtn && (toggleBtn.style.display = 'none');
          } else {
            root.classList.remove('vpCF-hidden-desktop');
            fab && (fab.style.display = 'none');
            toggleBtn && (toggleBtn.style.display = 'none');
          }
        };

        const openForm = () => {
          userToggled = true;
          restoreFormUI();
          if (!root) return;
          if (isMobile()) {
            root.classList.add('vpCF-visible');
            root.classList.remove('vpCF-hidden-desktop');
            fab && (fab.style.display = 'none');
          } else {
            root.classList.remove('vpCF-hidden-desktop');
            toggleBtn && (toggleBtn.style.display = 'none');
          }
        };
        const closeForm = () => {
          userToggled = true;
          if (!root) return;
          if (isMobile()) {
            root.classList.remove('vpCF-visible');
            root.classList.add('vpCF-hidden-desktop');
            fab && (fab.style.display = 'flex');
          } else {
            root.classList.add('vpCF-hidden-desktop');
            toggleBtn && (toggleBtn.style.display = 'inline-flex');
          }
          closeOptionsPortal();
        };

        window.vpCF = window.vpCF || {};
        window.vpCF.open = openForm;
        window.vpCF.close = closeForm;

        function placeOptions() {
          if (!display || !options) return;
          const r = display.getBoundingClientRect();
          options.style.left = r.left + 'px';
          options.style.top  = (r.bottom + 6) + 'px';
          options.style.width = r.width + 'px';
        }
        function openOptionsPortal() {
          if (!options || !multi || portaled) return;
          document.body.appendChild(options);
          options.classList.add('portaled', 'active');
          placeOptions();
          portaled = true;
          window.addEventListener('resize', placeOptions);
          window.addEventListener('scroll', placeOptions, true);
        }
        function closeOptionsPortal() {
          if (!options || !multi || !portaled) return;
          multi.appendChild(options);
          options.classList.remove('portaled', 'active');
          options.removeAttribute('style');
          portaled = false;
          window.removeEventListener('resize', placeOptions);
          window.removeEventListener('scroll', placeOptions, true);
        }

        window.addEventListener('DOMContentLoaded', setInitial);
        window.addEventListener('resize', setInitial);
        closeBtn && closeBtn.addEventListener('click', closeForm);
        toggleBtn && toggleBtn.addEventListener('click', () => {
          if (!root) return;
          if (root.classList.contains('vpCF-hidden-desktop')) openForm(); else closeForm();
        });
        fab && fab.addEventListener('click', openForm);

        display && display.addEventListener('click', (e) => {
          e.stopPropagation();
          if (portaled) closeOptionsPortal(); else openOptionsPortal();
        });
        document.addEventListener('click', (e) => {
          const insideMulti = e.target.closest('.vpCF-multi');
          const insideOptions = options && options.contains(e.target);
          if (!insideMulti && portaled && !insideOptions) closeOptionsPortal();
        });

        if (options) {
          options.addEventListener('change', () => {
            const checked = Array.from(options.querySelectorAll('input[type="checkbox"]:checked')).map(i => i.value);
            if (display) display.textContent = checked.length
              ? (checked.length === 1 ? checked[0] : `${checked.length} books selected`)
              : 'Select books';
          });
        }

        document.addEventListener('click', (e) => {
          const btn = e.target.closest('#pricing .btn-primary, .btn-primary');
          if (!btn) return;
          e.preventDefault();
          if (window.vpCF && typeof window.vpCF.open === 'function') {
            window.vpCF.open();
            const first = document.querySelector('#vpCF input[name="name"]');
            if (first) first.focus({ preventScroll: true });
          } else {
            const widget = document.getElementById('vpCF');
            if (widget) widget.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });

        if (form) {
          form.addEventListener('submit', async (e) => {
            e.preventDefault();

            if (options) {
              const checked = Array.from(options.querySelectorAll('input[type="checkbox"]:checked')).map(i => i.value);
              if (!checked.length) { alert('Please select at least one book'); return; }
            }

            const fd = new FormData(form);
            const checked = options ? Array.from(options.querySelectorAll('input[type="checkbox"]:checked')).map(i => i.value) : [];
            const data = {
              name:         fd.get('name'),
              email:        fd.get('email'),
              phone:        fd.get('phone') || '',
              organization: fd.get('organization'),
              represent:    fd.get('represent'),
              students:     fd.get('students'),
              books:        checked.join(', '),
              startDate:    fd.get('startDate'),
              budget:       fd.get('budget'),
              timestamp:    new Date().toISOString()
            };

            if (submitBtn) { submitBtn.classList.add('loading'); submitBtn.disabled = true; submitBtn.textContent = 'Sending...'; }
            try {
              const GOOGLE_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbziePI-VwyiC2GrXfIWMVS-TJzixcaJHuto5tBHm0_wVM-rXn51zh1Uh4DUNbOa7fn6tA/exec';
              if (GOOGLE_SCRIPT_URL && GOOGLE_SCRIPT_URL.startsWith('http')) {
                const body = new URLSearchParams(data);
                await fetch(GOOGLE_SCRIPT_URL, { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body });
              } else {
                await new Promise(r => setTimeout(r, 800));
              }

              if (isMobile()) {
                if (toast) { toast.style.display = 'block'; setTimeout(() => { toast.style.display = 'none'; }, 4000); }
                showOnlySuccess('Thanks! Your message has been sent. We’ll get back to you shortly.');
                closeForm();
              } else {
                showOnlySuccess('Thanks! Your message has been sent. We’ll get back to you shortly.');
              }
            } catch (err) {
              console.error(err);
              alert('There was an error submitting your form. Please try again.');
            } finally {
              if (submitBtn) { submitBtn.classList.remove('loading'); submitBtn.disabled = false; submitBtn.textContent = 'Submit'; }
            }
          });
        }

        const scrollTopBtn = document.getElementById('scrollTopBtn');
        if (scrollTopBtn) {
          window.addEventListener('scroll', () => {
            scrollTopBtn.style.display = (window.scrollY > 100) ? 'block' : 'none';
          }, { passive: true });
        }
        window.scrollToTop = function () { window.scrollTo({ top: 0, behavior: 'smooth' }); };
      })();
